import { render, staticRenderFns } from "./my_related_institutions_tab.vue?vue&type=template&id=62e9b9cb"
import script from "./my_related_institutions_tab.vue?vue&type=script&lang=js"
export * from "./my_related_institutions_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports